// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3oZuO","rightAdornment":"Header_rightAdornment__1Q9Dc"};